import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, Platform, ToastController} from 'ionic-angular';
import {UpdateRegistrationPage} from '../update-registration/update-registration';
import {NewSubscriptionStep1Page} from "../new-subscription-step1/new-subscription-step1";
import {NewSubscriptionStep4Page} from '../new-subscription-step4/new-subscription-step4';
import {QuizzAboutPage} from '../quizz-about/quizz-about';

import {AuthProvider} from '../../providers/auth/auth';
import {ValidatorProvider} from '../../providers/validator/validator';
import {AlertProvider} from '../../providers/alert/alert';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {SubscriptionServerProvider} from '../../providers/subscription-server/subscription-server';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';
import {NewSubscriptionProvider} from "../../providers/new-subscription/new-subscription";

import {NewSubscription} from '../../models/newsubscription';
import {ProofListPage} from "../proof-list/proof-list";
import {RegistrationProvider} from '../../providers/registration/registration';
import {QuizzServerProvider} from '../../providers/quizz-server/quizz-server';

import * as Config from "../../app/app.config";

/**
 * Generated class for the SubscriptionListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-subscription-list',
  templateUrl: 'subscription-list.html',
})
export class SubscriptionListPage {

  loading: boolean;
  private subscriptions: any = [];
  private doUpdateSubscription: any;
  public newSubscription: NewSubscription;
  public proofs: any[] = [];
  public kind = '';
  private sub: any;
  public certificatedUrl: string = Config.certificatedUrl;

  private canContractQuizz: boolean = false;
  private canContractQuizzSubscription: any;

  constructor(
    private navCtrl: NavController,
    private platform: Platform,
    private authProvider: AuthProvider,
    private validateProvider: ValidatorProvider,
    private alertProvider: AlertProvider,
    private networkMonitor: NetworkMonitorProvider,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private subscriptionServerProvider: SubscriptionServerProvider,
    private eventEmitterProvider: EventEmitterProvider,
    private newSubscriptionProvider: NewSubscriptionProvider,
    private registrationProvider: RegistrationProvider,
    private quizzServerProvider: QuizzServerProvider
  ) {
    this.newSubscription = new NewSubscription();
    this.loading = false;

    this.networkMonitor.setCallback(null);
    this.networkMonitor.stop();

    let that = this;
    this.doUpdateSubscription = this.eventEmitterProvider.get('do_update').subscribe(() => {
      that.doUpdate();
    });

    if (Config.quizzEnabled) {
      this.canContractQuizzSubscription = this.eventEmitterProvider.get('can_contract_quizz').subscribe((canContractQuizz: boolean) => {
        console.log('SubscriptionListPage.canContractQuizz', canContractQuizz);

        if ((canContractQuizz !== null) && (canContractQuizz !== undefined)) {
          that.canContractQuizz = canContractQuizz;
        } else {
          that.canContractQuizz = true;
        }
      });

      if (this.quizzServerProvider.getCanContractQuizz()) {
        this.canContractQuizz = true;
      }
    }

    if (this.quizzServerProvider.getCanContractQuizz()) {
      this.canContractQuizz = true;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SubscriptionListPage');
    this.doUpdate();
  }

  ionViewWillLeave() {
    this.doUpdateSubscription.unsubscribe();

    if (Config.quizzEnabled) {
      this.canContractQuizzSubscription.unsubscribe();
    }
  }

  onNext() {
    this.navCtrl.push(NewSubscriptionStep1Page, {
      animation: 'ios-transition'
    });
  }

  doUpdate() {
    this.loading = true;

    let loader = this.loadingCtrl.create({
      content: 'Obtendo as inscrições...',
    });
    loader.present();

    let that = this;
    this.subscriptions = [];

    this.subscriptionServerProvider.fetchAll().subscribe((subscriptions: any) => {
      that.loading = false;

      try {
        if (subscriptions.length > 0) {
          for (let pi = 0; pi < subscriptions.length; pi++) {
            let subscription = subscriptions[pi];

            for (let ai = 0; ai < subscription.activities.length; ai++) {
              let activity = subscription.activities[ai];
              //activity.canRetake = false;

              if (activity.kind.code === 'CTRLS') {
                activity.certificateUrl = that.subscriptionServerProvider.getCertificateUrl(subscription.id, subscription.certificateToken);
              } else if ((activity.kind.code === 'PRRLS') && ((subscription.auditReason) && ((subscription.auditReason.kind == 'FL')))) {
                activity.canRetake = false;
              } else if (activity.kind.code === 'NEWSB') {


              }
              subscription.activities[ai] = activity;
            }

            // if (proof.createdAt) {
            //   proof.createdAt = new Date(proof.createdAt.replace(/\s+/g, 'T').concat('.000-03:00'));
            // }

            // if (proof.finishedAt) {
            //   proof.finishedAt = new Date(proof.finishedAt.replace(/\s+/g, 'T').concat('.000-03:00'));
            // }

            that.subscriptions.push(subscription);
          }
        }
      } catch (ex) {
        that.doNotRetrivedSubscriptions(ex);
      }
      loader.dismiss();
    }, (error: any) => {
      that.loading = false;
      loader.dismiss();
      that.doNotRetrivedSubscriptions(error);
    });
  }

  private doNotRetrivedSubscriptions(error = null) {
    this.subscriptions = [];

    console.log('Não foi possível obter as inscrições.', error);

    let toast = this.toastCtrl.create({
      message: 'Não foi possível obter as inscrições.',
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  // doRetake(id: number) {
  //   let that = this;
  //   let user = this.authProvider.getUser();
  //   let message = null;
  //
  //     // DONE: On mobile HTML tag on message do not work
  //     if (this.platform.is('cordova')) {
  //       message = 'Tentaremos realizar uma reinscrição. Deseja continuar?';
  //     } else {
  //       message = 'Tentaremos realizar uma reinscrição. Deseja continuar?';
  //     }
  //
  //     this.alertProvider.doConfirm(message, () => {
  //       that.subscriptionServerProvider.retake(id).subscribe((data: any) => {
  //         if ((data) && (data.action)) {
  //           switch (data.action) {
  //             case 'generated_proof':
  //               that.alertProvider.doAlert('Sua prova foi autorizada.', 'Informe');
  //               that.navCtrl.setRoot(MainPage);
  //               that.navCtrl.popToRoot({
  //                 animation: 'ios-transition'
  //               }, () => {
  //                 that.eventEmitterProvider.get('do_update').emit();
  //               });
  //               break;
  //
  //             case 'affiliated_required':
  //               that.alertProvider.doAlert('Forneça o CNPJ da Empresa para poder fazer a reinscrição.', 'Aviso');
  //               that.navCtrl.push(UpdateRegistrationAffiliatedPage, null, {
  //                 animation: 'ios-transition'
  //               });
  //               break;
  //
  //             case 'affiliated_not_linked':
  //               that.alertProvider.doAlert('Forneça outro CNPJ de Empresa para poder fazer a reinscrição. O fornecido não tem vínculo com a agregradora.', 'Aviso');
  //               that.navCtrl.push(UpdateRegistrationAffiliatedPage, null, {
  //                 animation: 'ios-transition'
  //               });
  //               break;
  //
  //             case 'forbidden':
  //               that.alertProvider.doAlert('Você está proibido de fazer a reinscrição.', 'Aviso');
  //               break;
  //
  //             case 'payment_required':
  //               // TODO: Boleto
  //               that.alertProvider.doAlert('Acabaram as tentativas gratuitas. É necessário realizar um pagamento para poder fazer a reinscrição.', 'Aviso');
  //               break;
  //
  //             default:
  //               that.alertProvider.doAlert('Não foi possível solicitar a reinscrição.', 'Atenção');
  //               break;
  //           }
  //         } else {
  //           that.alertProvider.doAlert('Não foi possível solicitar a reinscrição.', 'Atenção');
  //         }
  //       }, (error: any) => {
  //         console.log(error);
  //         that.alertProvider.doAlert('Não foi possível solicitar a reinscrição.', 'Atenção');
  //       });
  //     });
  //
  //
  // }

  // doRenew(id: number) {
  //   let that = this;
  //   let user = this.authProvider.getUser();
  //   let message = null;
  //
  //   // if (this.validateProvider.isEmpty(user.affiliatedFederalCode)) {
  //   //   this.alertProvider.doAlert('Forneça o CNPJ da Empresa para poder fazer a renovação.', 'Aviso');
  //   //   this.navCtrl.push(UpdateRegistrationAffiliatedPage, null, {
  //   //     animation: 'ios-transition'
  //   //   });
  //   // } else {
  //
  //     // DONE: On mobile HTML tag on message do not work
  //     // if (this.platform.is('cordova')) {
  //     //   message = 'Tentaremos realizar uma renovação com o CNPJ ' + user.affiliatedFederalCode + '. Atualize seu cadastro caso deseje mudar o CNPJ. Deseja continuar?';
  //     // } else {
  //     //   message = 'Tentaremos realizar uma renovação com o <strong>CNPJ ' + user.affiliatedFederalCode + '</strong>. Atualize seu cadastro caso deseje mudar o CNPJ. Deseja continuar?';
  //     // }
  //
  //     this.alertProvider.doConfirm(message, () => {
  //       that.subscriptionServerProvider.renew(id).subscribe((data: any) => {
  //         if ((data) && (data.action)) {
  //           switch (data.action) {
  //             case 'generated_proof':
  //               that.alertProvider.doAlert('Sua prova foi autorizada.', 'Informe');
  //               that.navCtrl.setRoot(MainPage);
  //               that.navCtrl.popToRoot({
  //                 animation: 'ios-transition'
  //               }, () => {
  //                 that.eventEmitterProvider.get('do_update').emit();
  //               });
  //               break;
  //
  //             case 'affiliated_required':
  //               that.alertProvider.doAlert('Forneça o CNPJ da Empresa para poder fazer a renovação.', 'Aviso');
  //               that.navCtrl.push(UpdateRegistrationAffiliatedPage, null, {
  //                 animation: 'ios-transition'
  //               });
  //               break;
  //
  //             case 'affiliated_not_linked':
  //               that.alertProvider.doAlert('Forneça outro CNPJ de Empresa para poder fazer a renovação. O fornecido não tem vínculo com a agregradora.', 'Aviso');
  //               that.navCtrl.push(UpdateRegistrationAffiliatedPage, null, {
  //                 animation: 'ios-transition'
  //               });
  //               break;
  //
  //             case 'forbidden':
  //               that.alertProvider.doAlert('Você está proibido de fazer a renovação.', 'Aviso');
  //               break;
  //
  //             case 'payment_required':
  //               // TODO: Boleto
  //               that.alertProvider.doAlert('Acabaram as tentativas gratuitas. É necessário realizar um pagamento para poder fazer a renovação.', 'Aviso');
  //               break;
  //
  //             default:
  //               that.alertProvider.doAlert('Não foi possível solicitar a renovação.', 'Atenção');
  //               break;
  //           }
  //         } else {
  //           that.alertProvider.doAlert('Não foi possível solicitar a renovação.', 'Atenção');
  //         }
  //       }, (error: any) => {
  //         console.log(error);
  //         that.alertProvider.doAlert('Não foi possível solicitar a renovação.', 'Atenção');
  //       });
  //     });
  // }

  // doComplement(id: number) {
  //   let that = this;
  //   let user = this.authProvider.getUser();
  //   let message = null;
  //
  //   if (this.validateProvider.isEmpty(user.affiliatedFederalCode)) {
  //     this.alertProvider.doAlert('Forneça o CNPJ da Empresa para poder fazer a reinscrição.', 'Aviso');
  //     this.navCtrl.push(UpdateRegistrationAffiliatedPage, null, {
  //       animation: 'ios-transition'
  //     });
  //   } else {
  //
  //     // DONE: On mobile HTML tag on message do not work
  //     if (this.platform.is('cordova')) {
  //       message = 'Tentaremos realizar uma reinscrição com o CNPJ ' + user.affiliatedFederalCode + '. Atualize seu cadastro caso deseje mudar o CNPJ. Deseja continuar?';
  //     } else {
  //       message = 'Tentaremos realizar uma reinscrição com o <strong>CNPJ ' + user.affiliatedFederalCode + '</strong>. Atualize seu cadastro caso deseje mudar o CNPJ. Deseja continuar?';
  //     }
  //
  //     this.alertProvider.doConfirm(message, () => {
  //       that.subscriptionServerProvider.complement(id).subscribe((data: any) => {
  //         if ((data) && (data.action)) {
  //           switch (data.action) {
  //             case 'generated_proof':
  //               that.alertProvider.doAlert('Sua prova foi autorizada.', 'Informe');
  //               that.navCtrl.setRoot(MainPage);
  //               that.navCtrl.popToRoot({
  //                 animation: 'ios-transition'
  //               }, () => {
  //                 that.eventEmitterProvider.get('do_update').emit();
  //               });
  //               break;
  //
  //             case 'affiliated_required':
  //               that.alertProvider.doAlert('Forneça o CNPJ da Empresa para poder fazer a reinscrição.', 'Aviso');
  //               that.navCtrl.push(UpdateRegistrationAffiliatedPage, null, {
  //                 animation: 'ios-transition'
  //               });
  //               break;
  //
  //             case 'affiliated_not_linked':
  //               that.alertProvider.doAlert('Forneça outro CNPJ de Empresa para poder fazer a reinscrição. O fornecido não tem vínculo com a agregradora.', 'Aviso');
  //               that.navCtrl.push(UpdateRegistrationAffiliatedPage, null, {
  //                 animation: 'ios-transition'
  //               });
  //               break;
  //
  //             case 'forbidden':
  //               that.alertProvider.doAlert('Você está proibido de fazer a reinscrição.', 'Aviso');
  //               break;
  //
  //             case 'payment_required':
  //               // TODO: Boleto
  //               that.alertProvider.doAlert('Acabaram as tentativas gratuitas. É necessário realizar um pagamento para poder fazer a reinscrição.', 'Aviso');
  //               break;
  //
  //             default:
  //               that.alertProvider.doAlert('Não foi possível solicitar a reinscrição.', 'Atenção');
  //               break;
  //           }
  //         } else {
  //           that.alertProvider.doAlert('Não foi possível solicitar a reinscrição.', 'Atenção');
  //         }
  //       }, (error: any) => {
  //         console.log(error);
  //         that.alertProvider.doAlert('Não foi possível solicitar a reinscrição.', 'Atenção');
  //       });
  //     });
  //
  //   }
  // }

  // selectComplement(proofId, kind: string) {
  //   this.proofid = 49;
  //   this.kind = 'NEW';
  //   this.newSubscription.proofId = proofId;
  //   // NEW - New Subscription
  //   // RNW - Renew Subscription
  //   // RNV - Renovation Subscription
  //   this.newSubscription.kind = kind;
  //
  //   console.log('Complement --->',this.newSubscription);
  //
  //   this.newSubscriptionProvider.saveDataAndGoToPage(this.newSubscription,
  //     NewSubscriptionStep2Page);
  // }

  goToNew() {
    this.navCtrl.push(NewSubscriptionStep4Page, null, {
      animation: 'ios-transition'
    });
  }


  goToProofs() {
    this.navCtrl.setRoot(ProofListPage);
    this.navCtrl.popToRoot({
      animation: 'ios-transition'
    });
  }

  //
  // doRelease(id: number) {
  //     let that = this;
  //     let user = this.authProvider.getUser();
  //     console.log('doRelease - User ------>' ,user);
  //     console.log('doRelease - Id ------>' ,id);
  //   this.subscriptionServerProvider.processedPayment(id).subscribe((data: any) => {
  //     console.log('Retorno processedPayment: ', data);
  //     if ((data) && (data.result)) {
  //       console.log('processedPayment OK !');
  //       that.authProvider.setUser(user);
  //       that.alertProvider.doAlert('Sua prova foi autorizada.', 'Informe');
  //       that.navCtrl.setRoot(MainPage);
  //       that.navCtrl.popToRoot({
  //       animation: 'ios-transition'
  //     }, () => {
  //          that.eventEmitterProvider.get('do_update').emit();
  //     });
  //       //   } else {
  //       //     that.alertProvider.doAlert('Não foi possivel processar pagamento.', 'Atenção');
  //       }
  //   });
  //     // this.subscriptionServerProvider.processedPayment(id).subscribe((data: any) => {
  //     //   console.log('Retorno da verificacao: ', data);
  //     //   if ((data) && (data.result)) {
  //     //     that.authProvider.setUser(user);
  //     //     that.alertProvider.doAlert('Sua prova foi autorizada.', 'Informe');
  //     //     that.navCtrl.setRoot(MainPage);
  //     //     that.navCtrl.popToRoot({
  //     //       animation: 'ios-transition'
  //     //     }, () => {
  //     //       that.eventEmitterProvider.get('do_update').emit();
  //     //     });
  //     //   } else {
  //     //     that.alertProvider.doAlert('Não foi possivel processar pagamento.', 'Atenção');
  //     //   }
  //     // }, (error: any) => {
  //     //   console.log(error);
  //     //   that.alertProvider.doAlert('Erro no processamento do pagamento.', 'Atenção');
  //     // });
  //
  // }

  goToNewSubscription() {
    if (this.isAbleToContinue()) {
      this.navCtrl.push(NewSubscriptionStep4Page);
    }
  }

  private isAbleToContinue() {
    let ableToContinue = true;

    // this.registrationProvider.isComplete((result) => {
    //   if (!result) {
    //     ableToContinue = false;
    //
    //     let that = this;
    //
    //     this.alertProvider.doAlert('Você precisa atualizar seu cadastro para poder continuar.', null, (): void => {
    //       that.navCtrl.setRoot(UpdateRegistrationPage);
    //       that.navCtrl.popToRoot({
    //         animation: 'ios-transition'
    //       });
    //     });
    //   }
    // });

    return ableToContinue;
  }

  goToQuizzAboutPage() {
    this.navCtrl.setRoot(QuizzAboutPage);
    this.navCtrl.popToRoot({
      animation: 'ios-transition'
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/subscription-list/subscription-list.ts